<template>
    <div class="container">
        会员中心
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "MemberCenter",
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
      typeList:[1,2,3,4,5,6,7,8,9,10],
      valveList:[],
    }
  },
  created () {

  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    // width:100%;
    height: 100vh;
    position: relative;
    background:rgba(255,255,255,1);
    .flex(column);

}
</style>